// True when an event runs online/virtually. Uses the explicit is_virtual flag
// when set, and otherwise infers it from the location/room text so events
// created before the flag existed (e.g. "Online Zoom Room") still filter.
export const isVirtualEvent = (e) =>
  !!(e && e.is_virtual) ||
  /\b(online|virtual|zoom|webinar|remote|livestream)\b/i.test(`${e?.location || ""} ${e?.room || ""}`);
